import { configureStore } from '@reduxjs/toolkit';
import { initialState as company } from 'src/pages/CompanyPage/_BLL/slice';
import { initialState as report } from 'src/pages/ReportPage/api/database/slice';
import { initialState as notifications } from '../../pages/app/_BLL/notifications/slice';
import { initialState as userInfo } from '../../pages/MainPage/_BLL/slice';
import { initialState as recommendations } from 'src/widgets/AIInsightsMC/_BLL/slice';
import { loadState, saveState } from './localStorage';
import { rootReducer } from './rootReducer';

const preloadedState = loadState();

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
		}),
	devTools: { trace: false },
	preloadedState,
});

store.subscribe(() => {
	saveState({
		notifications,
		auth: store.getState().auth,
		userInfo,
		report,
		metaDictionaries: store.getState().metaDictionaries,
		company,
		recommendations,
	});
});

export type AppDispatch = typeof store.dispatch;
